export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ19.15ae5b06.mp3";